interface CarouselProgressProps {
  total: number
  activeIndex: number
  labels?: string[]
}

export function CarouselProgress({ total, activeIndex, labels }: CarouselProgressProps) {
  return (
    <div className="mt-2 text-center">
      <div className="flex items-center justify-center gap-1.5">
        {Array.from({ length: total }, (_, index) => (
          <span
            key={labels?.[index] ?? index}
            className={`h-2 w-2 rounded-full ${
              index === activeIndex
                ? "bg-[var(--color-text-primary)]"
                : "bg-[var(--color-divider)]"
            }`}
          />
        ))}
      </div>
      <p className="mt-1 text-xs text-[var(--color-text-secondary)]">
        {activeIndex + 1} of {total}
      </p>
    </div>
  )
}
